<template lang="pug">
  .cookie-banner.fixed.md-sticky.z-30.md-z-10.top-0.md-top-auto.md-bottom-0.left-0.md-mt-10.w-full
    //- row
    .w-full.bg-white.p-10.flex.justify-between.items-center.border-b.md-border-b-0.md-border-t(v-if="!acceptedCookies && policyLink")
      //- (spacer md)
      .hidden.md-block.w-150.flex-shrink-0
      //- msg
      .text-13(style="max-width:42em")
        | We are using cookies to offer a better online experience. You can read our <wp-link :link="policyLink" class="hover-text-app-text">cookies policy</wp-link>
      //- accept
      button.flex-shrink-0.w-110.md-w-150.h-82.flex.items-center.justify-center.text-13.border.leading-none.hover-text-app-text.hover-border-current.trans-fast(@click="accept") Accept
    //- row
    .w-full.bg-white.p-10.flex.justify-between.items-center.border-b.md-border-b-0.md-border-t(v-if="!acceptedCookies && policyLink")
      //- (spacer md)
      .hidden.md-block.w-150.flex-shrink-0
      //- msg
      .text-13(style="max-width:42em")
        | We are using cookies to offer a better online experience. You can read our <wp-link :link="policyLink" class="hover-text-app-text">cookies policy</wp-link>
      //- accept
      button.flex-shrink-0.w-110.md-w-150.h-82.flex.items-center.justify-center.text-13.border.leading-none.hover-text-app-text.hover-border-current.trans-fast(@click="accept") Accept
</template>

<script>
import { mapState } from 'vuex'
import wpLink from '@/components/WPLink'
export default {
  name: 'CookieBanner',
  computed: {
    ...mapState(['site', 'acceptedCookies']),
    policyLink () {
      return this.site && this.site.privacy_policy_link
    }
  },
  methods: {
    accept () {
      this.$store.commit('ACCEPT_COOKIES')
    }
  },
  components: { wpLink }
}
</script>

<style>
</style>
